import Markdown from "react-markdown";
import { Box, useTheme } from "@mui/material";
import MatchHighlighter from "catalog/components/MatchHighlighter";
import stripMarkdown from "strip-markdown";

const ResultDescription = (props: { description: string; highlight?: string[] }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        overflow: "hidden",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 3,
        fontSize: 14,
        color: theme.palette.text.secondary,
        lineHeight: "20px",
        "& > *": { m: 0, p: 0 },
      }}
    >
      {props.highlight ? (
        <MatchHighlighter text={props.description} highlight={props.highlight} />
      ) : (
        <Markdown remarkPlugins={[stripMarkdown]}>{props.description}</Markdown>
      )}
    </Box>
  );
};

export default ResultDescription;
